import { useState, useEffect } from 'react';
import { useAuth } from './useAuth';
import { supabase } from '@/integrations/supabase/client';

export const useOnboarding = () => {
  const { user } = useAuth();
  const [isFirstTime, setIsFirstTime] = useState<boolean | null>(null);
  const [loading, setLoading] = useState(true);

  const checkOnboarding = async () => {
    if (!user) {
      setLoading(false);
      return;
    }

    try {
      // Check if profile exists
      const { data: profile } = await supabase
        .from('profiles')
        .select('id')
        .eq('user_id', user.id)
        .maybeSingle();

      // Check if user has any workouts
      const { data: workouts } = await supabase
        .from('workouts')
        .select('id')
        .eq('user_id', user.id)
        .limit(1);

      const hasCompletedOnboarding = profile !== null && workouts && workouts.length > 0;
      setIsFirstTime(!hasCompletedOnboarding);
    } catch (error) {
      console.error('Error checking onboarding:', error);
      setIsFirstTime(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkOnboarding();
  }, [user]);

  const completeOnboarding = async () => {
    if (!user) return;

    try {
      // Create profile if not exists
      const { error } = await supabase
        .from('profiles')
        .upsert({ user_id: user.id }, { onConflict: 'user_id' });

      if (error) throw error;
      setIsFirstTime(false);
    } catch (error) {
      console.error('Error completing onboarding:', error);
    }
  };

  const resetOnboarding = () => {
    setIsFirstTime(true);
    // Aguarda um pouco antes de refazer o check para garantir que o estado seja atualizado
    setTimeout(() => {
      checkOnboarding();
    }, 100);
  };

  return {
    isFirstTime,
    loading,
    completeOnboarding,
    resetOnboarding,
    refetch: checkOnboarding,
  };
};
